import axiosInstance from '../axiosInstance';

/**
 * 발행된 아티클 목록
 * @param {{ category?: string, keyword?: string }} params
 */
export const getArticles = async ({ category, keyword } = {}) => {
  try {
    const response = await axiosInstance.get('/articles', {
      params: {
        ...(category ? { category } : {}),
        ...(keyword ? { keyword } : {}),
      },
    });
    return response.data.data ?? [];
  } catch (error) {
    console.error('Get Articles API Error:', error);
    throw error;
  }
};

/** 카테고리·키워드 필터 옵션 */
export const getArticleFilters = async () => {
  try {
    const response = await axiosInstance.get('/articles/filters');
    return response.data.data ?? { categories: [], keywords: [] };
  } catch (error) {
    console.error('Get Article Filters API Error:', error);
    return { categories: [], keywords: [] };
  }
};

/* ---------------------------------------------------------------- */
/* 어드민 (ROLE_A 전용)                                              */
/* ---------------------------------------------------------------- */

/** 초안·검토·숨김을 포함한 전체 아티클 */
export const getAdminArticles = async () => {
  try {
    const response = await axiosInstance.get('/articles/admin');
    return response.data.data ?? [];
  } catch (error) {
    console.error('Get Admin Articles API Error:', error);
    throw error;
  }
};

/**
 * 백엔드는 실패해도 HTTP 200에 본문 code만 다르게 내려주는 경우가 있다.
 * axios는 이를 성공으로 처리하므로 여기서 명시적으로 걸러낸다.
 */
const ensureOk = (payload) => {
  if (payload?.code && payload.code !== 200) {
    throw new Error(payload.msg || 'Request failed');
  }
  return payload;
};

/** 웹에서 감춘다 (노션 상태를 숨김으로 변경) */
export const hideArticle = async (pageId) => {
  const response = await axiosInstance.patch(
    `/articles/admin/${encodeURIComponent(pageId)}/hide`,
  );
  return ensureOk(response.data);
};

/** 웹에 공개한다 (상태를 발행 완료로 변경). Publish / Set as Active 공용 */
export const publishArticle = async (pageId) => {
  const response = await axiosInstance.patch(
    `/articles/admin/${encodeURIComponent(pageId)}/publish`,
  );
  return ensureOk(response.data);
};

/** 노션 휴지통으로 보낸다 (노션에서 복구 가능) */
export const deleteArticle = async (pageId) => {
  const response = await axiosInstance.delete(
    `/articles/admin/${encodeURIComponent(pageId)}`,
  );
  return ensureOk(response.data);
};

/** 아티클 상세 (본문 blocks 포함) */
export const getArticleBySlug = async (slug) => {
  try {
    const response = await axiosInstance.get(
      `/articles/${encodeURIComponent(slug)}`,
    );
    return response.data.data ?? null;
  } catch (error) {
    console.error('Get Article Detail API Error:', error);
    throw error;
  }
};
